import { __debug } from "../Debug/Debug";
import { Timer } from "../Timer/Timer";


/**
 * CallbackManagerTimer class
 */
export class CallbackManagerTimer {

    private name: string = "";
    private callback: any;
    private callEmptyOnDestroy: boolean = false;
    private warnings: boolean = true;
    private __emptyCallback: any = {
        onEmpty: (callback: Function) => {
            if (!this.isCallback(callback)) {
                __debug.warn(() => {
                    console.warn("Please provide a callback for [onEmpty] function");
                });
                return;
            }
            callback();
        }
    }
    private __emptyCallbackSingnature = {
        onEmpty: (callback: Function) => {
            if(this.callEmptyOnDestroy) {
                callback();
            }
            
        }
    }
    private timer: Timer | undefined;
    private timout = 86400; // on day expire time by default

    /**
     * Manages callback functions
     * @param {string} name name
     * @param {number=} [timout=86400] [86400ms] on day expire time by default
     * @param {boolean=} warnings warnings
     * 
     */
    constructor(name: string, timout: number, warnings: boolean = true) {
        this.name = name;
        this.timout = timout;
        this.warnings = warnings;
    }

    /**
     * registers a callback
     * @param {Function} callback
     * @returns {void} returns nothing
     */
    register = (callback: Function) => {
        if (!this.isCallback(callback)) {
            __debug.warn(() => {
                console.warn("Please provide a valid callback function!");
            });
            return;
        }
        this.destroyCallback();
        this.callback = callback;
        this.initNewTimer();
    }
    /**
     * triggers the callbacks registered via the (registerCallback) method
     * @param {any} data
     * @returns {void} returns nothing
     */
    trigger = (data: any) => {
        this.callEmptyOnDestroy = false;

        if (this.isEmpty()) {
            if (this.warnings) {
                __debug.warn(() => {
                    console.warn(`No callbacks registered for: [${this.name}]`);
                });
            }
            return this.__emptyCallback;
        }
        // trigger callbacks
        this.callback(data);
        this.clearTimer();
        this.initNewTimer();
        return this.__emptyCallbackSingnature;
    }

    isCallback = (callback: Function) => {
        return (typeof callback === "function");
    }

    /**
     * determines if there are no callback registered.
     * @returns {boolean} true or false
     */
    isEmpty = () => {
        return !this.isCallback(this.callback);
    }

    destroyCallback = () => {
        __debug.warn(() => {
            console.warn(`destroyCallback ${this.name}`);
        });
        this.callback = null;
        this.clearTimer();
    }

    public destroyAndCallEmpty = () => {
        __debug.warn(() => {
            console.warn("destroyAndCallEmpty");
        });
        this.callEmptyOnDestroy = true;
    }

    initNewTimer = () => {
        this.timer = new Timer({
            timeout: this.timout,
            callback: () => {
                this.destroyCallback();
                //console.warn("fragment callback destroyed!");
            }
        })
    }
    clearTimer = () => {
        this.timer?.clear();
    }


}

// test data
// const testCallback = new CallbackManagerTimer("testCallback", false);

// const onTestCallback = (callback) => {
//     testCallback.register(callback);
// }

// onTestCallback((data) => {
//     console.log(data);
// });

// testCallback.trigger({ data: "the data - 1" })
//     .onEmpty(() => {
//         console.log("on empty - 1");
//     });

// setTimeout(() => {
//     testCallback.trigger({ data: "the data - 2" })
//         .onEmpty(() => {
//             console.log("on empty - 2");
//         });
// }, 2000);

// setTimeout(() => {
//     testCallback.trigger({ data: "the data - 3" })
//         .onEmpty(() => {
//             console.log("on empty - 3");
//         });
// }, 4000);

// setTimeout(() => {
//     testCallback.trigger({ data: "the data - 4" })
//         .onEmpty(() => {
//             console.log("on empty - 4");
//         });
// }, 6000);

// setTimeout(() => {
//     testCallback.trigger({ data: "the data - 5" })
//         .onEmpty(() => {
//             console.log("on empty - 5");
//         });
// }, 10000);

